import { Link, useOutletContext } from 'react-router-dom'
import { LiveJobsDashboard } from '../components/LiveJobsDashboard'

export function DashboardPage() {
  const { socket } = useOutletContext()

  return (
    <>
      <div className="quick-links">
        <Link to="/accounts" className="quick-link-card">
          <h3>Accounts</h3>
          <p>Add IMAP mailboxes and start syncing emails.</p>
        </Link>
        <Link to="/jobs" className="quick-link-card">
          <h3>Jobs &amp; Activity</h3>
          <p>Watch live progress and review past sync runs.</p>
        </Link>
        <Link to="/contacts" className="quick-link-card">
          <h3>Contacts</h3>
          <p>Browse classified contacts and sentiment analysis.</p>
        </Link>
      </div>

      <section className="section">
        <h2>Live Job Activity</h2>
        <LiveJobsDashboard socket={socket} />
      </section>
    </>
  )
}
